import { constants } from './actions'
import { commonConstants } from '../common/actions'
const { REQUEST, SUCCESS, FAILURE } = commonConstants
const { GET_CALL_TAKER, FETCH_ALL_CALL_TAKERS, CREATE_CALL_TAKER, UPDATE_CALL_TAKER, UPDATE_USER_FORM_FIELD, RESET_USER_FORM_FIELDS } = constants

const initState = {
  // Form fields - text inputs
  id: '',
  username: '',
  firstName: '',
  lastName: '',
  email: '',
  cellPhone: '',
  homePhone: '',
  birthDay: '',
  birthMonth: '',
  initialTrainingClassNumber: '',
  initialTrainingClassCity: '',
  initialTrainingClassDate: '',
  notes: '',
  zip: '',
  address: '',
  city: '',
  // Form fields - dropdowns/special
  enabled: null,
  roles: null,
  availableForScheduling: null,
  location: null,
  country: null,
  initialTrainingClassLocation: null,
  initialTrainingClassCountry: null,
  // State management
  success: {},
  loading: {},
  error: {},
  callTaker: {},
  callTakers: []
}

export default function reducer (state = initState, action) {
  switch (action.type) {
    case GET_CALL_TAKER + REQUEST:
      return {
        ...state,
        success: {},
        loading: { source: GET_CALL_TAKER },
        error: {}
      }
    case GET_CALL_TAKER + SUCCESS:
      return {
        ...state,
        success: action.payload,
        loading: {},
        callTaker: action.payload
      }
    case GET_CALL_TAKER + FAILURE:
      return {
        ...state,
        success: {},
        loading: {},
        error: action.payload,
      }

    case FETCH_ALL_CALL_TAKERS + REQUEST:
      return {
        ...state,
        success: {},
        loading: { source: FETCH_ALL_CALL_TAKERS },
        error: {}
      }
    case FETCH_ALL_CALL_TAKERS + SUCCESS:
      return {
        ...state,
        success: action.payload,
        loading: {},
        error: {},
        callTakers: action.payload,
      }
    case FETCH_ALL_CALL_TAKERS + FAILURE:
      return {
        ...state,
        success: {},
        loading: {},
        error: action.payload,
      }
    case CREATE_CALL_TAKER + REQUEST:
      return {
        ...state,
        success: {},
        loading: { source: CREATE_CALL_TAKER },
        error: {}
      }
    case CREATE_CALL_TAKER + SUCCESS:
      return {
        ...state,
        success: action.payload,
        loading: {},
        error: {},
      }
    case CREATE_CALL_TAKER + FAILURE:
      return {
        ...state,
        success: {},
        loading: {},
        error: action.payload
      }

    case UPDATE_CALL_TAKER + REQUEST:
      return {
        ...state,
        success: {},
        loading: { source: UPDATE_CALL_TAKER },
        error: {}
      }
    case UPDATE_CALL_TAKER + SUCCESS:
      return {
        ...state,
        success: action.payload,
        loading: {},
        error: {}
      }
    case UPDATE_CALL_TAKER + FAILURE:
      return {
        ...state,
        success: {},
        loading: {},
        error: action.payload
      }

    case UPDATE_USER_FORM_FIELD:
      return {
        ...state,
        [action.field]: action.value,
        loading: {},
        error: {},
        success: {}
      }

    case RESET_USER_FORM_FIELDS:
      const success = action.payload?.showMessage
        ? { source: RESET_USER_FORM_FIELDS, message: 'All form fields were successfully reset.' }
        : {}

      return {
        ...initState,
        ...action.payload?.fieldData,
        success,
        loading: {},
        error: {}
      }

    default:
      return state
  }
}
